// src/components/Footer.js
import "../../styles/Components.css";

function Footer() {
  return (
    <footer className="footer">
      © Drive A Tank.com {new Date().getFullYear()}
      <div className="disclaimer">
        All site information, including prices, availability, and details, may
        change without notice. Drive A Tank may modify or substitute
        offerings as needed.
      </div>
    </footer>
  );
}

export default Footer;
